import { useState, useEffect } from 'react';
import { getPayrolls } from '../../../api/payroll';
import { useCompany } from '../../../contexts/CompanyContext';

export function usePayrolls() {
  const [payrolls, setPayrolls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentCompany } = useCompany();

  useEffect(() => {
    if (currentCompany?.id) {
      loadPayrolls();
    }
  }, [currentCompany]);

  const loadPayrolls = async () => {
    try {
      setLoading(true);
      const response = await getPayrolls(currentCompany.id);
      // getPayrolls retorna directamente un array
      const payrollsArray = Array.isArray(response) ? response : [];
      setPayrolls(payrollsArray);
      setError(null);
    } catch (err) {
      console.error('Error loading payrolls:', err);
      setError(err.message);
      setPayrolls([]);
    } finally {
      setLoading(false);
    }
  };

  const reload = () => {
    loadPayrolls();
  };

  return {
    payrolls,
    loading,
    error,
    reload
  };
}

export default usePayrolls;
